import { FiCheckCircle, FiAlertTriangle, FiXCircle, FiArchive } from 'react-icons/fi';
import i18n from '../i18n';

/**
 * Etiquetas de usuario compartidas por el gestor, el detalle y la sidebar.
 * Antes estaban duplicadas en cada pantalla y se desincronizaban.
 *
 * Son getters (no objetos estáticos): el label se resuelve en el idioma
 * activo en el momento de leer la propiedad, no en el momento en que se
 * importó el módulo — así un cambio de idioma en caliente los sigue
 * reflejando sin recargar la página.
 */
const getters = (claves, prefijo) => {
    const obj = {};
    claves.forEach((clave) => {
        Object.defineProperty(obj, clave, {
            enumerable: true,
            get: () => i18n.t(`${prefijo}.${clave}`),
        });
    });
    return obj;
};

export const ROL_LABELS = getters(['admin', 'tecnico', 'user'], 'usuarios.roles');

// 'archivado' es el estado de una cuenta dada de baja conservando su historial
export const ESTADOS = ['verificar', 'verificado', 'suspendido', 'archivado'];

export const ESTADO_LABELS = getters(ESTADOS, 'usuarios.estados');

export const ESTADO_LABELS_LARGO = getters(ESTADOS, 'usuarios.estadosLargo');

export const ESTADO_ICONOS = {
    verificar: FiAlertTriangle,
    verificado: FiCheckCircle,
    suspendido: FiXCircle,
    archivado: FiArchive,
};

export const DEPTO_LABELS = getters(
    ['no_asignado', 'no_especificado', 'desarrollo', 'marketing', 'diseno', 'redes_sociales'],
    'usuarios.departamentos',
);

// La sidebar rotula el departamento en corto para que quepa en su ancho
export const DEPTO_LABELS_CORTO = getters(
    ['desarrollo', 'marketing', 'diseno', 'redes_sociales'],
    'usuarios.departamentosCorto',
);

export const esStaff = (role) => role === 'admin' || role === 'tecnico';
